import { type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { useExperimentsContext } from '../../../../experiments/components/ExperimentsContext'
import { experimentAccessorIsMarketplace } from '../../../../experiments/model/experimentAccessor'
import { useGlobalConfigContext } from '../../../../global-config'

export const useBarcodeTypesTranslationMap = (): ReactNode[] => {
  const { tenant } = useGlobalConfigContext()
  const { experiments } = useExperimentsContext()
  const isMarketplace = experimentAccessorIsMarketplace(experiments, tenant)

  const translationsValues = {
    h3: (str: ReactNode): JSX.Element => (
      <h3 className="mb-4 text-s font-medium">{str}</h3>
    ),
    // eslint-disable-next-line id-length -- id has to be same as html element
    p: (str: ReactNode): JSX.Element => (
      <p className="font-normal text-dark-primary-strong">{str}</p>
    ),
  }

  return [
    <FormattedMessage
      id="product.barcodes.modal.pzn.body"
      key="product.barcodes.modal.pzn.body"
      values={translationsValues}
    />,
    <FormattedMessage
      id="product.barcodes.modal.ean.body"
      key="product.barcodes.modal.ean.body"
      values={translationsValues}
    />,
    ...(isMarketplace
      ? [
          <FormattedMessage
            id="product.barcodes.modal.isbn.body"
            key="product.barcodes.modal.isbn.body"
            values={translationsValues}
          />,
        ]
      : []),
    <FormattedMessage
      id="product.barcodes.modal.upid.body"
      key="product.barcodes.modal.upid.body"
      values={translationsValues}
    />,
  ]
}
